import { Controller } from "@hotwired/stimulus"
import { initializePaddle } from "../lib/paddle"

let paddleReady = false

export default class PaddleCheckoutController extends Controller {
  static values = {
    clientToken: String,
    environment: String,
    customerId: String
  }

  declare clientTokenValue: string
  declare environmentValue: string
  declare customerIdValue: string

  connect() {
    initializePaddle({
      token: this.clientTokenValue,
      environment: this.environmentValue,
      eventCallback: (data) => {
        if (data.name === "checkout.completed") window.location.reload()
      }
    })
      .then(() => {
        paddleReady = true
      })
      .catch((error) => {
        console.error("Paddle initialization failed", error)
      })
  }

  openCheckout({ params }: { params: { priceId: string } }) {
    if (!paddleReady) return
    Paddle.Checkout.open({
      customer: { id: this.customerIdValue },
      items: [{ priceId: params.priceId, quantity: 1 }]
    })
  }
}
